(() => {
  'use strict';

  const indicators = new Map();

  const initIndicators = () => {
    document.querySelectorAll('.menu-quicklinks').forEach(section => {
      const container = section.querySelector('.menu-quicklinks__container');
      const indicator = section.querySelector('.menu-quicklinks__indicator');
      if (!container || !indicator) return;

      const update = () => {
        const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 4;
        indicator.classList.toggle('menu-quicklinks__indicator--hidden', atEnd);
      };

      indicator.addEventListener('click', () => {
        container.scrollBy({ left: 160, behavior: 'smooth' });
      });

      container.addEventListener('scroll', update, { passive: true });
      indicators.set(section, update);

      // Initial check
      update();
    });
  };

  // Keep the global object but minimal
  window.convertMenuQuicklinks = {
    init: function() {
      initIndicators();
    }
  };

  // Auto initialize
  const init = () => {
    initIndicators();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:load', init);
  document.addEventListener('shopify:section:load', init);

})();